import React, { useState } from "react";
import { dispatchConsentChange, getCookieConsent } from "../../helper/analyticsConsent";

const Cookies = () => {
    const [visible, setVisible] = useState(() => !getCookieConsent());

    const acceptCookies = () => {
        dispatchConsentChange("accepted");
        setVisible(false);
    };

    const declineCookies = () => {
        dispatchConsentChange("declined");
        setVisible(false);
    };

    if (!visible) return null;

    return (
        <div
            role="dialog"
            aria-label="Cookie consent"
            className="fixed bottom-6 right-6 left-6 sm:left-auto w-auto sm:max-w-lg mx-auto sm:mx-0 bg-white text-black border border-gray-100 rounded-2xl p-4 sm:p-5 shadow-[0_8px_30px_rgba(0,0,0,0.08)] z-50"
        >
            <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4">
                <div className="flex-1 min-w-0">
                    <h3 className="text-sm font-semibold mb-1">Ne përdorim cookies</h3>
                    <p className="text-xs text-gray-600">
                        Ne përdorim cookies për të përmirësuar përvojën tuaj. Duke vazhduar përdorimin e faqes, ju pranoni
                        politikën tonë të cookies.{" "}
                        <a href="/cookie-policy" className="underline hover:no-underline text-black font-medium" tabIndex={0}>
                            Mësoni më shumë
                        </a>
                    </p>
                </div>

                <div className="flex-shrink-0 flex gap-3">
                    <button
                        onClick={declineCookies}
                        className="px-3 py-2 rounded-lg border border-gray-300 bg-white text-black text-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-black/20 transition"
                        aria-label="Decline cookies"
                    >
                        Nuk Pranoj
                    </button>

                    <button
                        onClick={acceptCookies}
                        className="px-4 py-2 rounded-lg bg-black text-white text-sm font-medium hover:bg-neutral-800 focus:outline-none focus:ring-2 focus:ring-black/30 transition flex items-center gap-2"
                        aria-label="Accept cookies"
                    >
                        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden>
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                        </svg>
                        Prano
                    </button>
                </div>
            </div>
        </div>
    );
};

export default Cookies;
